
import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "../productpages/bannerForFooter";
import clintservicesimage from '../../../images/footerLinksImages/support/clintservices.png'
function ClintService() {
    const keywords = [
        { title: "Consulting Services", summary: "Expert advice to help your business grow, optimize operations, and solve complex challenges." },
        { title: "Customer Support", summary: "24/7 assistance for all product and service-related inquiries, ensuring your satisfaction." },
        { title: "Project Management", summary: "End-to-end project management services that ensure timely delivery and effective resource utilization." },
        { title: "Business Strategy", summary: "Strategic planning and execution to help businesses achieve their long-term goals and competitive advantage." },
        { title: "Product Development", summary: "Comprehensive services to take your product from ideation to market, ensuring quality and scalability." },
        { title: "Branding & Marketing", summary: "Build and promote your brand through tailored marketing strategies to engage your target audience." },
        { title: "Training & Workshops", summary: "Customized training programs to upskill your team and improve business efficiency." },
        { title: "Financial Advisory", summary: "Get expert advice on managing investments, financial planning, and optimizing cash flow." },
        { title: "IT Support", summary: "Reliable IT services to ensure the security, maintenance, and seamless operation of your technology infrastructure." },
        { title: "Customer Feedback", summary: "Collect and analyze feedback to improve services, products, and customer satisfaction." },
      ];
      
    return (<>
        <Header />
        
        <BannerFooter
            title="Clint Services"
            text="Client Services are designed to ensure that customers receive top-tier support throughout their journey with a company. These services focus on delivering personalized solutions tailored to the client’s specific needs, from consultation to after-sales support. Client Services typically include assistance with account management, order fulfillment, problem resolution, and regular follow-up to ensure satisfaction. By providing dedicated customer care, Client Services teams aim to foster long-term relationships, offering value-added services that align with clients' goals, enhancing customer satisfaction, and ensuring that clients feel supported and valued at every step of their experience."
            imageone={clintservicesimage}
            imagetwo={clintservicesimage}
        />
        <div className="container-fluid py-5 bg-light">
  <div className="container p-4 shadow-lg bg-white rounded">
    <h2 className="text-center mb-4">Client Services</h2>
    <div className="accordion" id="clientServicesAccordion">
      {keywords.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header" id={`heading-${index}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${index}`}
              aria-expanded="false"
              aria-controls={`collapse-${index}`}
              style={{ transition: "all 0.3s ease" }}
            >
              {item.title}
            </button>
          </h2>
          <div
            id={`collapse-${index}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading-${index}`}
            data-bs-parent="#clientServicesAccordion"
          >
            <div className="accordion-body">
              {item.summary}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

        <ContactForm />
        <Footer />
    </>)
}

export default ClintService